/** Production on Vercel: VITE_API_URL=/api (proxied via middleware). Local: direct Nest or /api + vite proxy. */
export const API_URL =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.DEV ? 'http://localhost:3000' : '/api');
